import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AvailableShares } from 'modules/main/actions/heirsTransfer/models/heir';

interface HeirsState {
	availableShares: AvailableShares;
}

const initialState: HeirsState = {
	availableShares: {
		free_common: 0,
		suspended_common: 0,
		mortgaged_common: 0,
		free_preferred: 0,
		suspended_preferred: 0,
		mortgaged_preferred: 0,
	},
};

const heirsSlice = createSlice({
	name: 'heirs',
	initialState,
	reducers: {
		setAvailableShares(state, action: PayloadAction<AvailableShares>) {
			state.availableShares = action.payload;
		},
		resetHeirsState() {
			return initialState;
		},
	},
});

export const { setAvailableShares, resetHeirsState } = heirsSlice.actions;
export default heirsSlice.reducer;
